<template>
  <div>
    <label class="item-name">{{initComponent.name}}</label>
    <div class="component-content">
      <el-input disabled/>
    </div>
  </div>
</template>

<script>
import { componentMixin } from '../mixins'
export default {
  name: 'rc-children-input',
  props: ['initComponent'],
  mixins: [ componentMixin ],
  data () {
    return {
      component: this.initComponent
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/components/input/rc-children-input.vue